<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Editar Contato</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="col-md-4">
                      <label for="wa_id">Número (WhatsApp ID):</label>
                      <input type="text" id="wa_id" class="form-control" v-model="contato.wa_id" disabled />
                    </div>
                    <div class="col-md-4">
                      <label for="nome">Nome:</label>
                      <input autocomplete="new-password" type="text" id="nome" class="form-control" v-model="contato.nome" />
                    </div>
                    <div class="col-md-4">
                      <label for="nome_perfil">Nome do perfil (WhatsApp):</label>
                      <input type="text" id="nome_perfil" class="form-control" v-model="contato.nome_perfil" disabled />
                    </div>
                  </div>
                  <div class="form-row mt-1">
                    <div class="col-md-6">
                      <label for="bloqueado">Bloqueio:</label>
                      <select v-model="contato.bloqueado" class="form-control">
                        <option :value="false">Liberado</option>
                        <option :value="true">Bloqueado</option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label for="status">Status:</label>
                      <select v-model="contato.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <div class="form-group mt-1">
                    <div class="block text-right">
                      <router-link to="/contatos" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "contatoAdd",
  data() {
    return {
      contato: {},
      errors: undefined,
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "contatos";

      if (self.contato.id) {
        self.contato._method = "PUT"
        api += "/" + self.contato.id;
      }

      axios
        .post(api, self.contato)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/contatos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getContato: function (id) {
      const self = this;
      const api = self.$store.state.api + "contatos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.contato = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getContato(id);
    }
  },
};
</script>
